import React, {Component} from 'react';
import PropTypes from 'prop-types';

class CustomDateTimeInput extends Component {
  render () {
    return (
      <button
        className={`btn ${this.props.className}`}
        onClick={(e) => { e.preventDefault(); this.props.onClick(e); }}>
        {this.props.value}
      </button>
    )
  }
}

CustomDateTimeInput.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string
};

export default CustomDateTimeInput;



// WEBPACK FOOTER //
// ./src/components/SmartForm/CustomDateTimeInput.js